import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { User } from '../entity/user.entity';
import { environment } from '../../../environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UserApiService {
  constructor(private http: HttpClient) {}

  fetchCurrentUser(): Observable<User> {
    return this.http
      .get<{ data: User }>(`${environment.apiUrl}/api/user/me`)
      .pipe(map(data => data.data));
  }

  patchCurrentUser(user: Partial<User>): Observable<User> {
    return this.http
      .patch<{ data: User }>(`${environment.apiUrl}/api/user/me`, user)
      .pipe(map(data => data.data));
  }
}
